import React, {Component} from 'react';
import { PropTypes } from 'prop-types';
import {Container, Row, Col, CardGroup, Card, CardBody, CardTitle, ListGroup, ListGroupItem, Label 
      } from 'reactstrap';
import EnvConfig from '../../../config/env'

class LoginIssue extends Component {
  // Pass the correct proptypes in for validation
  static propTypes = {
    handleSubmit: PropTypes.func,
  }
 
  constructor(props) {
    super(props);
  }

  backToLogin = () => {
    this.props.history.push('/login');
  }
  
  forgotPasswordClick = (e) => {
    e.preventDefault();
    this.props.history.push('/forgotPassword');
  }
  
  reSendConfirmationAccClick = (e) => {
    e.preventDefault();
    this.props.history.push('/reconfirmation');
  }
  
  render() {
    const {  
      handleSubmit, // remember, Redux Form injects this into our props
    } = this.props
    
    return (
      <div className="app flex-row align-items-center bg-master ">
        <Container>
          <Row>
            <Col md="12">
            <div className="logo">
              <a href={EnvConfig.HTML_REF}>
                  <img alt="Logo" src="../img/logo.png" />
              </a>
            </div>
            </Col>
          </Row>
          <Row className="justify-content-center">
            <Col md="6" sm="10" xs="12">
              <CardGroup>
                <Card className="p-3">
                  <CardBody>
                    <CardTitle>Bạn không thể đăng nhập?</CardTitle>
                    <ListGroup>
                      <ListGroupItem tag="a" href="#" onClick={this.forgotPasswordClick} action>Quên mật khẩu?</ListGroupItem>
                      <ListGroupItem tag="a" href="#" onClick={this.reSendConfirmationAccClick} action>Quên chưa kích hoạt tài khoản</ListGroupItem>
                    </ListGroup>
                  </CardBody>
                  <CardBody>
                    <a href="#" onClick={this.backToLogin} className="card-link">Quay lai trang đăng nhập</a>
                  </CardBody>
                </Card>
              </CardGroup>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default LoginIssue;



// WEBPACK FOOTER //
// ./src/views/Pages/LoginIssue/LoginIssue.js